import { render, staticRenderFns } from "./MessageReview.vue?vue&type=template&id=8af0e70a&"
import script from "./MessageReview.vue?vue&type=script&lang=js&"
export * from "./MessageReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports